import React, { Component } from "react";
import { Row, Col, Card, Divider, Button, Input, Select } from "antd";
import styled from "styled-components";
import {
  BsCalendarMinus,
  MdOutlineBusiness,
  MdContactPhone,
  MdAudiotrack,
  AiOutlinePlaySquare,
  MdNote,
  FaImages,
  BiNote,
  GrTest,
  AiFillStar,
} from "react-icons/all";
import CreditCard from "../../components/EmployeCard/creditcard";
import { connect } from "react-redux";
import { DashboardAction } from "../../store/actions";
import moment from "moment";
import CustomModal from "../../components/modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";
import FileView from "../../components/fileView";
import Configuration from "../../assets/images/configuration.png";
const { Option } = Select;
const OrderNumWrapper = styled(Card)`
  min-height: 250px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
`;
const { TextArea } = Input;
class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      isOpenReject: false,
      documentModal: false,
      isTesting: false,
      isOpenViewMix: false,
      isDispatchModal: false,
      logValue: "",
      isSelect: false,
      row: 2,
      isReadMore: false,
      isOpenDeleteModal: false,
      isOpenNotesModal: false
    };
  }
  componentDidMount() {
    const {
      getOrderDetail,
      match: {
        params: { id },
      },
    } = this.props;
    getOrderDetail(id);
  }
  onCancelModal = () => {
    this.setState({
      isOpenModal: false,
    });
  };
  componentDidUpdate(preProps) {
    if (preProps.match.params.id !== this.props.match.params.id) {
      this.props.getOrderDetail(this.props.match.params.id);
    }
  }
  render() {
    const { OrderDetail, approvedOrder, logistics } = this.props;

    //
    const { meta_asset = {} } = OrderDetail;
    let inputRef;

    const filterViewMix = (
      OrderDetail?.order_products?.[0]?.order_product_additives || []
    ).filter((item) => {
      return item.selected;
      //
    });

    return (
      <Row justify="space-around">
        <Col xl={9}>
          {/* xs={24} sm={24} lg={12} */}
          <OrderNumWrapper>
            <Row align="middle">
              <Col xl={2} xs={4} sm={3} md={2} lg={2}>
                <span className="pm-circle am-pm-circle">
                  {OrderDetail?.preferred_delivery_period}
                </span>
              </Col>
              <Col xl={11} md={10} lg={13} xxl={18}>
                <h5>{`Order# ${OrderDetail?.order_number}`}</h5>
              </Col>
              <Col xl={22} md={22} lg={23} xxl={22} className="text-left">
                <span>
                  {OrderDetail.purchase_order_num ?
                    `PO#: ${OrderDetail.purchase_order_num} ` : ""
                  }
                </span>
              </Col>
            </Row>
            <Row>
              <Col xl={4}>
                <span
                  className={
                    OrderDetail.status == 2 || OrderDetail.status === 6
                      ? "orange order-status-label"
                      : "green order-status-label"
                  }
                >
                  {OrderDetail.status == 2 && "PENDING"}
                  {OrderDetail.status === 4 && "Approved"}
                  {OrderDetail.status === 6 && "Dispatched"}
                  {OrderDetail.status === 5 && "Rejected"}
                  {OrderDetail.status === 7 && "Completed"}
                </span>
              </Col>
              <Col xl={9}>
                <span style={{ padding: "6px" }}>
                  <BsCalendarMinus size="13" color="grey" />
                </span>
                <span>
                  {moment(OrderDetail?.preferred_delivery_datetime).format(
                    "LL"
                  )}
                </span>
              </Col>
            </Row>
            <Row>
              <Col>
                <h6 class="ordercsh">Contractor Info</h6>
              </Col>
            </Row>
            <Row>
              <Col className="contractor-avatar">
                <MdOutlineBusiness size="20" color="white" />
              </Col>
              <Col xl={20}>
                <h5 className="text-left" style={{ marginLeft: "14px" }}>
                  {`${OrderDetail?.contractor?.user?.first_name} ${OrderDetail?.contractor?.user?.last_name}`}
                </h5>
                <p className="text-left" style={{ marginLeft: "14px" }}>
                  <small style={{ fontSize: "80%" }}>
                    {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.address}`}
                  </small>
                  <br></br>
                  <small style={{ fontSize: "80%" }}>
                    {`${OrderDetail?.order_addresses?.[0]?.contractors_address?.phone}`}
                  </small>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xl={24}></Col>
              <Divider />
            </Row>
            <Row>
              <Col>
                <h6 class="ordercsh">Shipping Address</h6>
              </Col>
            </Row>
            <Row>
              <Col className="contractor-avatar">
                <MdContactPhone size="20" color="white" />
              </Col>
              <Col xl={20}>
                <h5 className="text-left" style={{ marginLeft: "14px" }}>
                  {`${OrderDetail?.contractor?.user?.first_name} ${OrderDetail?.contractor?.user?.last_name}`}
                </h5>
                <p className="text-left" style={{ marginLeft: "14px" }}>
                  <small style={{ fontSize: "80%" }}>
                    {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.address}`}
                  </small>
                  <br></br>
                  <small style={{ fontSize: "80%" }}>
                    {`${OrderDetail?.order_addresses?.[1]?.contractors_address?.phone}`}
                  </small>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xl={24}></Col>
              <Divider />
            </Row>
            {OrderDetail?.order_note ? (
              <Row>
                <Col xl={24}>
                  <h3 className="text-left orderdetail-heading">
                    Order Checkout Note
                  </h3>
                </Col>
                <Col xl={24}>
                  <div
                    className="checkout-note"
                    style={{ height: this.state.isReadMore ? "auto" : "3rem" }}
                  >
                    {OrderDetail.order_note}
                  </div>
                  {OrderDetail.order_note.length > 150 ? (
                    <p
                      className="st-primary text-left pointer-cursor"
                      onClick={() =>
                        this.setState({
                          isReadMore: !this.state.isReadMore,
                        })
                      }
                    >
                      {this.state.isReadMore ? "READ LESS" : "READ MORE"}
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            ) : null}

            <Row style={{ padding: "10px" }}>
              <Col span={24}>
                <h3 className="text-left orderdetail-heading">MEDIA ADDED</h3>
              </Col>
              <Col span={24}>
                <Row justify="space-between">
                  <Col
                    className="contractor-avatar pointer-cursor"
                    style={{ background: "#5C6BC0" }}
                  >
                    <MdAudiotrack color="white" size="20" />
                  </Col>

                  <Col
                    className="contractor-avatar pointer-cursor"
                    style={{ background: "#2196F3" }}
                  >
                    <AiOutlinePlaySquare color="white" size="20" />
                  </Col>

                  <Col
                    className="contractor-avatar pointer-cursor"
                    style={{ background: "#4CAF50" }}
                  >
                    <MdNote color="white" size="20"
                      onClick={() =>
                        OrderDetail.note &&
                        this.setState({
                          isOpenNotesModal: true
                        })
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={24}>
                <Row justify="space-between">
                  <Col xl={5} className="pointer-cursor text-left">
                    <small className="small">
                      {meta_asset.videos} Audio Clips
                    </small>
                  </Col>
                  <Col xl={5} className="pointer-cursor text-left">
                    <small className="small">
                      {meta_asset.audios} Video Clips
                    </small>
                  </Col>
                  <Col
                    xl={4}
                    className="pointer-cursor text-center"
                    style={{ marginRight: "-10px" }}
                    onClick={() =>
                      OrderDetail?.note &&
                      this.setState({
                        isOpenNotesModal: true
                      })
                    }
                  >
                    <small className="small">Notes</small>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginTop: "1rem" }}>
                  <Col
                    className="contractor-avatar pointer-cursor "
                    style={{ background: "#E91E63" }}
                  >
                    <FaImages color="white" size="20" />
                  </Col>

                  <Col
                    className="contractor-avatar pointer-cursor"
                    style={{ background: "#FF9F00" }}
                  >
                    <BiNote
                      color="white"
                      size="20"
                      onClick={() =>
                        this.setState({
                          documentModal: true,
                        })
                      }
                    />
                  </Col>

                  <Col
                    className="contractor-avatar pointer-cursor"
                    style={{ background: "#01D1FE" }}
                  >
                    <GrTest
                      color="white"
                      size="20"
                      onClick={() =>
                        this.setState({
                          documentModal: true,
                          isTesting: true,
                        })
                      }
                    />
                  </Col>
                  <Col xl={24} xs={24} sm={24} md={24} lg={24}>
                    <Row justify="space-between">
                      <Col xl={4} className="pointer-cursor text-left">
                        <small className="small">
                          {meta_asset.images} Images
                        </small>
                      </Col>
                      <Col
                        xl={4}
                        className="pointer-cursor text-center"
                        onClick={() =>
                          this.setState({
                            documentModal: true,
                          })
                        }
                      >
                        <small className="small">
                          {meta_asset?.documents} Files
                        </small>
                      </Col>
                      <Col
                        xl={4}
                        className="pointer-cursor text-center"
                        style={{ marginRight: "-10px" }}
                        onClick={() =>
                          this.setState({
                            documentModal: true,
                            isTesting: true,
                          })
                        }
                      >
                        <small className="small">
                          {meta_asset?.test_documents} Testing
                        </small>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </OrderNumWrapper>
        </Col>
        <Col xl={14} md={18} lg={10} xs={24} sm={24}>
          <OrderNumWrapper>
            <Row gutter={[0, 10]} style={{ marginBottom: "10px" }}>
              <Col xl={24}>
                <h5 className="text-left">Order Details</h5>
              </Col>
              <Col span={24}>
                <Row className="ordertable-heading">
                  <Col span={12}>
                    <p className="text-left color-light-grey">PRODUCT</p>
                  </Col>
                  <Col span={6} xs={6}>
                    <p className="color-light-grey">QUANTITY</p>
                  </Col>
                  <Col span={6} xs={6}>
                    <p className="color-light-grey">PRICE</p>
                  </Col>
                </Row>
              </Col>
            </Row>
            {(OrderDetail?.order_products || []).map((item) => {
              let total_amount = item?.order_product_additives?.filter((v) => {
                return v.selected;
              });
              let p = 0;
              let c = (total_amount || []).map((d) => {
                p = p + Number(d.rmx_product_additive.price);
                return p;
              });

              return (
                <Row>
                  <Col span={12}>
                    <Row gutter={[20, 0]}>
                      <Col span={5}>
                        <img
                          width={"52px"}
                          height={"52px"}
                          src={item?.rmx_product?.image?.medium}
                        />
                      </Col>
                      <Col
                        xl={12}
                        xs={24}
                        sm={24}
                        md={24}
                        lg={14}
                        className="text-left"
                      >
                        <span>{item?.rmx_product?.name}</span> <br />
                        <span>{`$${item?.rmx_product?.price
                          ? item?.rmx_product?.price
                          : ""
                          }/${item?.rmx_product?.unit}`}</span>
                        <br />
                        <span
                          className="view-link"
                          onClick={() =>
                            this.setState({
                              isOpenViewMix: true,
                            })
                          }
                        >
                          VIEW MIX
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={6}>
                    <p>
                      <p>{`${item?.quantity}`}</p>
                    </p>
                  </Col>
                  <Col span={6}>
                    <p>${p + Number(item?.rmx_product?.price)}</p>
                  </Col>
                </Row>
              );
            })}

            <Row style={{ marginTop: "1rem" }}>
              <Col xl={24}></Col>
              <Divider />
            </Row>
          </OrderNumWrapper>
          <Row style={{ border: "solid 1px lightgrey", marginTop: "1rem" }}>
            <Col xl={10} sm={24} xs={24} md={24}>
              <CreditCard
                cardStyle={{
                  color: "black",
                  fontSize: "15px",
                  width: "100%",
                  // style={{ border: "1px solid green" }},
                }}
                shipVisaStyling={true}
                paidText={true}
                cards={[]}
                fromOrder={true}
                data={OrderDetail?.order_stripe_charge?.charge}
                tickIcon={true}
              />
            </Col>
            <Col span={24} xl={12} lg={24} style={{ marginTop: "5px" }}>
              <Row>
                <Col span={12} className="text-left">
                  Subtotal
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.subtotal_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "1rem" }}>
                <Col span={12} className="text-left">
                  Shipping & Handling
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.shipping_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "1rem" }}>
                <Col span={12} className="text-left">
                  Tax
                </Col>
                <Col span={12} className="text-right">
                  <p
                    style={{ fontWeight: "500" }}
                  >{`$${OrderDetail?.tax_amount}`}</p>
                </Col>
              </Row>
              <Row style={{ marginTop: "1rem" }}>
                <Col span={12} className="text-left">
                  <strong>Grand Total</strong>
                </Col>
                <Col span={12} className="text-right">
                  <strong
                    style={{ color: "#31A99E" }}
                  >{`$${OrderDetail?.total_amount}`}</strong>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="end" style={{ marginTop: "1rem" }}>
            {OrderDetail.status == 2 && (
              <>
                <Col xl={4}>
                  <Button
                    style={{
                      backgroundColor: "#31A99E",
                      color: "#fff",
                      width: "100%",
                    }}
                    onClick={() =>
                      this.setState({
                        isOpenReject: true,
                      })
                    }
                  >
                    REJECT
                  </Button>
                </Col>
                <Col xl={4}>
                  <Button
                    style={{
                      backgroundColor: "#FF9800",
                      color: "#fff",
                      width: "100%",
                    }}
                    onClick={() =>
                      this.setState({
                        isOpenModal: true,
                      })
                    }
                  >
                    ACCEPT
                  </Button>
                </Col>
              </>
            )}
            {OrderDetail.status == 4 && (
              <Col xl={4}>
                <Button
                  style={{
                    backgroundColor: "#FF9800",
                    color: "#fff",
                    width: "100%",
                  }}
                  onClick={() => {
                    this.setState({
                      isDispatchModal: true,
                    });
                    this.props.getLogisticsReq();
                    this.props.getLogPartnerReq();
                  }}
                >
                  Dispatch
                </Button>
              </Col>
            )}
          </Row>
        </Col>
        <CustomModal
          visible={this.state.documentModal}
          onCancelModal={() =>
            this.setState({
              documentModal: false,
              isTesting: false,
            })
          }
          width={800}
          className="file-modal"
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => inputRef.click()}
                >
                  Upload
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col span={24}>
              <h3 className="text-left" style={{ color: "grey" }}>
                {this.state.isTesting ? "TEST" : "FILES"}
              </h3>
            </Col>
            {(this.state.isTesting
              ? OrderDetail?.order_assets?.test_documents
              : OrderDetail?.order_assets?.documents || []
            ).map((item) => {
              return (
                <FileView
                  item={item}
                  orderId={OrderDetail.id}
                  {...this.props}
                  isTesting={this.state.isTesting}
                />
              );
            })}

            {OrderDetail?.order_assets?.documents?.length === 0 && (
              <Col
                span={12}
                style={{ textAlign: "center", margin: "25%", color: "grey" }}
              >
                <span>Nothing to show right now</span>
              </Col>
            )}
          </Row>
        </CustomModal>
        <CustomModal
          visible={this.state.isDispatchModal}
          onCancelModal={() =>
            this.setState({
              isDispatchModal: false,
            })
          }
          width={600}
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#31A99E",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => {
                    approvedOrder(
                      OrderDetail.id,
                      () => {
                        this.onCancelModal();
                        this.props.history.push("/dashboard");
                      },
                      "dispatch",
                      this.state.logValue
                    );
                  }}
                >
                  Dispatch
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col span={24}>
              <h2 className="text-center st-primary">Dispatch</h2>
            </Col>
            <Col
              xl={24}
              className="select-categories"
              style={{ height: "50%" }}
            >
              <Select
                className="custom ant-select-selector"
                style={{ height: "100%" }}
                size="large"
                placeholder="Select logistics partner"
                name="basemix_category_id"
                onChange={(e) =>
                  this.setState({
                    logValue: e,
                  })
                }
              // onSelect={() =>
              //   this.setState({
              //     isSelect: true,
              //   })
              // }
              // open={!this.state.isSelect}
              // onFocus={() =>
              //   this.setState({
              //     isSelect: false,
              //   })
              // }
              >
                {logistics.map((item) => {
                  return (
                    <Option value={item.id}>
                      <div
                        className="text-left"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <img
                          src={item.users?.[0]?.image?.original}
                          height={"50"}
                          width={"50"}
                          style={{ borderRadius: "50%" }}
                        />

                        {item?.business_name}

                        <AiFillStar
                          color={item.favourite ? "#F9A01B" : "grey"}
                          size="25"
                          onClick={() => this.props.markAsFav(item.id)}
                        />
                      </div>

                      {/* <Row justify="space-between">
                        <Col span={20}>
                          <Row justify="space-between">
                            <Col span={2}>
                              <img
                                src={item.users?.[0]?.image?.original}
                                height={"50"}
                                width={"50"}
                                style={{ borderRadius: "50%" }}
                              />
                            </Col>
                            <Col span={12}>
                              <p className="text-left">{item?.business_name}</p>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={4}>
                          <AiFillStar
                            color={item.favourite ? "#F9A01B" : "grey"}
                            size="25"
                            onClick={() => this.props.markAsFav(item.id)}
                          />
                        </Col>
                      </Row> */}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <ul id="scroller">
              {(this.props.log_partner || []).map((item) => {
                return (
                  <li>
                    <span span={4}>
                      <img
                        src={item.users?.[0]?.image?.original}
                        height={"50"}
                        width={"50"}
                        style={{ borderRadius: "50%" }}
                      />
                    </span>
                    <span span={24}>
                      <p className="three-dot">
                        {item.users?.[0]?.first_name}{" "}
                        {item.users?.[0]?.last_name}
                      </p>{" "}
                    </span>
                  </li>
                );
              })}
            </ul>
            {/* <Row>
              {(this.props.log_partner || []).map((item) => {
                return (
                  <>
                    
                  </>
                );
              })}
            </Row> */}
          </Row>
        </CustomModal>

        <CustomModal
          visible={this.state.isOpenModal}
          onCancelModal={this.onCancelModal}
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "50%",
                    border: "none",
                  }}
                  onClick={() => {
                    this.setState({
                      isDispatchModal: true,
                    });
                    this.props.getLogisticsReq();
                    this.props.getLogPartnerReq();
                  }}
                >
                  ACCEPT & DISPATCH
                </Button>
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    approvedOrder(
                      OrderDetail.id,
                      () => {
                        this.onCancelModal();
                        this.props.history.push("/dashboard");
                      },
                      "approval"
                    )
                  }
                >
                  APPROVE
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <h1 className="st-primary">Approve Order</h1>
            </Col>
            <Col span={12} style={{ textAlign: "center" }}>
              <span>Are you sure you want to approve this order?</span>
            </Col>
          </Row>
        </CustomModal>
        <CustomModal
          visible={this.state.isOpenReject}
          onCancelModal={() =>
            this.setState({
              isOpenReject: false,
            })
          }
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    approvedOrder(
                      OrderDetail.id,
                      () => {
                        this.setState({
                          isOpenReject: false,
                        });
                        this.props.history.push("/dashboard");
                      },
                      "reject"
                    )
                  }
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    this.setState({
                      isOpenReject: false,
                    })
                  }
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col>
            <Col span={12} style={{ textAlign: "center" }}>
              <span>Are you sure you want to reject this order?</span>
            </Col>
          </Row>
        </CustomModal>
        <input
          type="file"
          ref={(ref) => (inputRef = ref)}
          accept=".docx,.pdf"
          className="d-none"
          onChange={(e) => {
            this.props.uploadDocReq(
              OrderDetail.id,
              {
                attachment: e.target.files[0],
                file: e.target.files[0],
                uploader_user_id: this.props?.user?.[0]?.user?.id,
              },
              { params: this.state.isTesting ? "test_documents" : "documents" }
            );
          }}
        />

        <CustomModal
          visible={this.state.isOpenViewMix}
          onCancelModal={() =>
            this.setState({
              isOpenViewMix: false,
            })
          }
          className="view-mix-modal"
          width={700}
          footer={[
            <Row justify="end">
              <Col span={24} style={{ width: "100%" }}>
                <Button
                  style={{
                    backgroundColor: "#ff9800 ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    this.setState({
                      isOpenViewMix: false,
                    })
                  }
                >
                  Close
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row
            justify="center"
            style={{ marginBottom: "30px" }}
            gutter={[10, 0]}
          >
            <Col>
              <span className="modal-headning">
                {OrderDetail?.order_products?.[0]?.rmx_product?.name}
              </span>
            </Col>

            <Divider />
          </Row>
          <Row>
            <Col span={9}>
              <img
                src={
                  OrderDetail?.order_products?.[0].rmx_product?.image?.medium
                }
                style={{ objectFit: "contain", width: "90%" }}
              />
            </Col>
            <Col
              span={14}
              style={{ border: "1px solid #F0F0F0", padding: "0.5rem" }}
            >
              <Row>
                <Col span={12} style={{ position: "relative" }}>
                  <img
                    src={Configuration}
                    style={{
                      width: "100%",
                      position: "absolute",
                      backgroundRepeat: "no-repeat",
                      top: "-20px",
                    }}
                  />
                </Col>
                <Col
                  span={24}
                  style={{
                    height: "8rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "5px",
                  }}
                >
                  {filterViewMix.map((item) => {
                    return (
                      <p style={{ marginTop: "35px" }}>
                        {item?.rmx_product_additive?.name}
                      </p>
                    );
                  })}
                </Col>
              </Row>
            </Col>
          </Row>
        </CustomModal>
        <CustomModal
          visible={this.state.isOpenNotesModal}
          onCancelModal={() =>
            this.setState({
              isOpenNotesModal: false
            })}
          footer={[
            <Row justify="start" style={{ margin: "20px" }}>
              <Col
                span={24}
                className="d-flex text-left"
                style={{ width: "100%" }}
              >
                <h6 style={{ color: "#09c1b2", fontSize: '1rem' }} className="text-left">NOTES</h6>
              </Col>
              <Col
                span={24}
                className="d-flex text-left"
                style={{ width: "100%" }}
              >
                <span className="text-left">{OrderDetail?.note}</span>
              </Col>
            </Row>
          ]}
        >
        </CustomModal>
      </Row>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    OrderDetail: store.DashboardReducer.orderDetail,
    user: store.AuthReducer.user,
    logistics: store.DashboardReducer.logistics,
    log_partner: store.DashboardReducer.log_partner,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetail: (id) => dispatch(DashboardAction.getOrderDetailReq(id)),
    approvedOrder: (id, cb, params, logId) =>
      dispatch(DashboardAction.OrderApprovalReq(id, cb, params, logId)),
    deleteDocReq: (orderId, docId, cb) =>
      dispatch(DashboardAction.deleteDocReq(orderId, docId, cb)),
    uploadDocReq: (orderId, payload, cb) =>
      dispatch(DashboardAction.uploadDocReq(orderId, payload, cb)),
    getLogisticsReq: () => dispatch(DashboardAction.getLogisticsReq()),
    getLogPartnerReq: () => dispatch(DashboardAction.getLogPartnerReq()),
    markAsFav: (id) => dispatch(DashboardAction.markAsFavReq(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);
